import React from 'react';

type NeedToSave = () => boolean;
type StartSave = (linkTo: string) => void;
type onClickType = (event: React.MouseEvent, link?: string) => void;
type Result = { href: string; onClick: onClickType };
export type INavigateAwayHelper = (href: string) => Result;
export const NavigateAwayHelper =
  (needToSave: NeedToSave, startSave: StartSave): INavigateAwayHelper =>
  (href: string) => {
    return {
      onClick: (event: React.MouseEvent, link?: string) => {
        if (needToSave()) {
          event.preventDefault();
          startSave(link || href);
        }
      },
      href,
    };
  };
export const forHashLink = (result: Result) => {
  return {
    to: result.href,
    onClick: (event: React.MouseEvent) => result.onClick(event, `#${result.href}`),
  };
};
